module.exports = __webpack_public_path__ + "static/media/tabletDesktopMobile.43d617e2.webp";